import * as React from "react";
import { forwardRef } from "react";
const SvgJapan = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 36", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#EEE", d: "M36 27c0 2.209-1.791 4-4 4H4c-2.209 0-4-1.791-4-4V9c0-2.209 1.791-4 4-4h28c2.209 0 4 1.791 4 4v18z" }), /* @__PURE__ */ React.createElement("circle", { fill: "#ED1B2F", cx: 18, cy: 18, r: 7 }));
const ForwardRef = forwardRef(SvgJapan);
export default ForwardRef;
